<template>
    <addresses-base :addresses="addresses">
        <template slot-scope="{ addressList }">
            <div class="card">
                <div class="card-header">
                    {{ __('Addresses') }}
                </div>
                <div class="card-body">
                    <div class="card-columns">
                        <transition-group
                            name="list-complete"
                            tag="div"
                        >
                            <address-item
                                v-for="address in addressList"
                                :key="address.id"
                                :address="address"
                            />
                        </transition-group>
                    </div>
                </div>
            </div>
        </template>
    </addresses-base>
</template>

<script>
export default {
    props: {
        addresses: {
            type: Array,
            default: () => []
        }
    }
}
</script>
